import React from "react";
import { Box, Grid } from "@mui/material";

interface HomePageLayoutProps {
  children: React.ReactNode;
  backgroundImage?: string;
}

const HomePageLayout: React.FC<HomePageLayoutProps> = ({
  children,
  backgroundImage = "/assets/images/login.jpg",
}) => {
  return (
    <Grid container spacing={0} sx={{ height: "100vh" }}>
      <Grid
        size={{ xs: 0, md: 6 }}
        sx={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: { xs: "none", md: "block" }, // ← Fully hides on mobile
        }}
      ></Grid>

      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",   // Vertical centering
          alignItems: "center",      // Horizontal centering
          padding: "10%", 
          backgroundImage: {
            xs: "url(/assets/images/login.jpg)",
            md: "none",
          },
          backgroundSize: "cover",
          backgroundPosition: "center",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(255, 255, 255, 0.6)", // Optional overlay tint
            display: { xs: "block", md: "none" }, // only on small screens
            zIndex: 0,
          }}
        />

        {/* Actual content */}
        <Box sx={{ position: "relative", zIndex: 1, width: "100%" }}>
          {children}
        </Box>
      </Grid>
    </Grid>
  );
};

export default HomePageLayout;
